export const AGENT_CHAT_PANE_WIDTH_PX = 500
